import React, { Component } from 'react';
//import {FormBlocks} from './FormBlocks';
//import {formFieldsAttributes} from '../../actions/FieldProps';
//import {formFieldsAttributes} from '../../../../../src/plugins/FormBuilder/actions/FieldProps';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import Wrp from '../../../hoc/Wrp/Wrp';
import { numericValidation} from '../../../Utils/CommonFunctions';
import 'react-datetime/css/react-datetime.css';
import {getDateFormat} from '../../../Utils/UserFunctions';
import {isSet} from '../../../Utils/CommonFunctions';
import {correctSegmentValue, getDefaultValueDateTime, getSegmentPositionsDateTime, isTextDateSegment, shouldPad} from'../../../Utils/DateUtils';
import MomentUtils from '@date-io/moment';
import {
  DatePicker,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// cyan lightBlue
import blue from "@material-ui/core/colors/blue";
import { setAndGetAttributes } from '../../FormInputFields/FormInputFunctions';

class DatePick extends Component {
  constructor(props) {
      super();
      this.state = {
        dt: moment(),
        setDt: moment()
      };
    }
   fieldOnChangeHandler = (moment)=>{
      const {changeHandler,attributes} = this.props;
      if (isSet(moment,null)!==null &&   typeof moment.format === "function") {
          const  systemFormat =  moment.format((isSet(getDateFormat('Date'),null)!==null)?getDateFormat('Date'):'YYYY-MM-DD'); //moment.format(getDateFormat('DateTime'))
          console.log("systemFormat",systemFormat);
          this.props.filterOnChange(systemFormat ,this.props.attr1, this.props.fieldtype, this.props.filterObject.has_multiple_input,this.props.attr5,this.props.attr6)
      }else{
        //changeHandler(null);
        this.props.filterOnChange(null ,this.props.attr1, this.props.fieldtype, this.props.filterObject.has_multiple_input,this.props.attr5,this.props.attr6)
      }
    } 
  render() {
    let filterObject = this.props.filterObject;     
    // console.log(this.props.value   + ' operator properties')
    let value = this.props.value;
    let classname = this.props.classname ? "form-control "+this.props.classname : "form-control";
    // console.log(getDateFormat('Date'), value);
    let attr = setAndGetAttributes(this.props);
    const dateFormat = (attr.getDateFormat!==undefined)?attr.getDateFormat:'YYYY-MM-DD';
    let dispValue = '';
    
    // if(dateFormat==='UNIX'){
    //   dispValue = (isSet(value,null)!==null)?moment(value):'';//.format(getDateFormat())
    // }else{
      dispValue = (isSet(value,null)!==null)?moment(value, dateFormat,true):'';//.format(getDateFormat())
    // }
    // console.log('dispValue',dateFormat,dispValue);
    const materialTheme = createTheme({
      palette: {
        primary: blue,
      },
    });

    
      
          const handleKeyDown = (e) => {
            const input = e.target;
            const key = e.key;
            const format = getDateFormat('Date');
            // const separator = format.match(/[^A-Za-z0-9]/)?.[0] || '/';
            const segments = getSegmentPositionsDateTime(format);
            let cursor = input.selectionStart;
            let value = input.value || getDefaultValueDateTime(format);
      
            const isDigit = /^\d$/.test(key);
            const isLetter = /^[a-zA-Z]$/.test(key);
            const isControl = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key);
            let didPad = false;
            const currentSegment = segments.find(seg => cursor >= seg.start && cursor <= seg.end);
            if (!currentSegment) return;
      
            const segIndex = segments.indexOf(currentSegment);
            const { start: segStart, end: segEnd } = currentSegment;
            const segLength = segEnd - segStart;
            const segVal = value.slice(segStart, segEnd);
            const isTextSegment = isTextDateSegment(currentSegment.part);
      
            if (!isControl && !((isDigit && !isTextSegment) || (isLetter && isTextSegment))) {
              e.preventDefault();
              return;
            }
      
            if (isDigit) {
              e.preventDefault();
      
              let positionInSegment = cursor - segStart;
              let segChars = segVal.split('');
              const isSegmentFullyFilled = !segChars.includes('_') && !segChars.includes(' ');
      
                // 👇 If segment is full, start fresh on first key press
                if (isSegmentFullyFilled && positionInSegment === 0) {
                  segChars = Array(segLength).fill('_');
                }
      
              // Shift left and insert new key at cursor
              segChars.splice(positionInSegment, 0, key);
              segChars = segChars.slice(0, segLength); // Ensure segment length
              const rawUpdated = segChars.join('').replace(/_/g, '');
      
              const segmentType = currentSegment.type;
              const digitsOnly = value.replace(/[^\d]/g, '');
      
              // Auto-pad logic
              if (shouldPad(segmentType, rawUpdated, digitsOnly)) {
                segChars = rawUpdated.padStart(segLength, '0').split('');
              }
      
              let updatedSegment = segChars.join('').padEnd(segLength, '_');
              // const digitsOnly = value.replace(/[^\d]/g, '');
      
              if (shouldPad(currentSegment.part, updatedSegment.replace(/_/g, ''), segChars.join(''))) {
                const corrected = correctSegmentValue(currentSegment.part, updatedSegment, digitsOnly);
                updatedSegment = corrected.padEnd(segLength, '_');
                didPad = true;
              }
              // console.log('currentSegment',updatedSegment);
              value = value.slice(0, segStart) + updatedSegment + value.slice(segEnd);
              input.value = value;
      
              const newCursor = segStart + positionInSegment + 1;
      
              queueMicrotask(() => {
                if (didPad && segIndex < segments.length - 1) {
                  // Move to next segment if padding was applied
                  const next = segments[segIndex + 1];
                  input.setSelectionRange(next.start, next.end);
                } else {
                  // const newCursor = segStart + positionInSegment + 1;
                  if (newCursor < segEnd) {
                    input.setSelectionRange(newCursor, newCursor);
                  } else if (segIndex < segments.length - 1) {
                    const next = segments[segIndex + 1];
                    input.setSelectionRange(next.start, next.end);
                  } else {
                    input.setSelectionRange(segStart, segEnd);
                  }
                }
                // if (newCursor < segEnd) {
                //   input.setSelectionRange(newCursor, newCursor);
                // } else if (segIndex < segments.length - 1) {
                //   const next = segments[segIndex + 1];
                //   input.setSelectionRange(next.start, next.end);
                // } else {
                //   input.setSelectionRange(segStart, segEnd);
                // }
              });
      
              const momentDate = moment(value, format, true);
              if (momentDate.isValid()) {
                this.fieldOnChangeHandler?.(momentDate);
              }
      
              return;
            }

            if (isLetter && isTextSegment) {
              e.preventDefault();

              const typedChar = (cursor - segStart) === 0 ? key.toUpperCase() : key.toLowerCase();
              let positionInSegment = cursor - segStart;
              let segChars = segVal.split('');
              const isSegmentFullyFilled = !segChars.includes('_') && !segChars.includes(' ');

              if (isSegmentFullyFilled && positionInSegment === 0) {
                segChars = Array(segLength).fill('_');
              }

              segChars.splice(positionInSegment, 0, typedChar);
              segChars = segChars.slice(0, segLength);
              let updatedSegment = segChars.join('').padEnd(segLength, '_');
              didPad = !updatedSegment.includes('_');

              value = value.slice(0, segStart) + updatedSegment + value.slice(segEnd);
              input.value = value;

              const newCursor = segStart + positionInSegment + 1;

              queueMicrotask(() => {
                if (didPad && segIndex < segments.length - 1) {
                  const next = segments[segIndex + 1];
                  input.setSelectionRange(next.start, next.end);
                } else if (newCursor < segEnd) {
                  input.setSelectionRange(newCursor, newCursor);
                } else if (segIndex < segments.length - 1) {
                  const next = segments[segIndex + 1];
                  input.setSelectionRange(next.start, next.end);
                } else {
                  input.setSelectionRange(segStart, segEnd);
                }
              });

              const momentDate = moment(value, format, true);
              if (momentDate.isValid()) {
                this.fieldOnChangeHandler?.(momentDate);
              }

              return;
            }
      
            if (key === 'Backspace') {
              e.preventDefault();
              let newValue = value;
              let newCursor = cursor;
              let currentIndex = segIndex;

              // Iterate segments backward if already cleared
              while (currentIndex >= 0) {
                const seg = segments[currentIndex];
                const segVal = newValue.slice(seg.start, seg.end);
                const isCleared = /^[_\s]*$/.test(segVal);

                if (!isCleared) {
                  const cleared = '_'.repeat(seg.end - seg.start);
                  newValue = newValue.slice(0, seg.start) + cleared + newValue.slice(seg.end);
                  newCursor = seg.start;
                  break;
                }
                currentIndex--;
              }

              input.value = newValue;
              queueMicrotask(() => {
                input.setSelectionRange(newCursor, newCursor);

                const allCleared = segments.every(seg => /^[_\s]*$/.test(newValue.slice(seg.start, seg.end)));
                if (allCleared) {
                  this.fieldOnChangeHandler(null);
                }
              });
              return;
            }
      
            if (key === 'ArrowRight' && segIndex < segments.length - 1) {
              e.preventDefault();
              const next = segments[segIndex + 1];
              input.setSelectionRange(next.start, next.end);
              return;
            }
      
            if (key === 'ArrowLeft' && segIndex > 0) {
              e.preventDefault();
              const prev = segments[segIndex - 1];
              input.setSelectionRange(prev.start, prev.end);
              return;
            }
          };
          
        // console.log('segments',getDefaultValueDateTime(format));
        const handleFocusOrClick = (e) => {
          const format = getDateFormat('Date');
          const input = e.target;
          
              if (!input.value) {
                input.value = getDefaultValueDateTime(format);
                try {
                  input.setSelectionRange(0, 0);
                } catch (e) {
                  // handle error silently
                }
              } else {
                const segments = getSegmentPositionsDateTime(format);
                const cursor = input.selectionStart || 0;
                const seg = segments.find(s => cursor >= s.start && cursor <= s.end) || segments[0];
                try {
                  input.setSelectionRange(seg.start, seg.end);
                } catch (e) {
                  // handle error silently
                }
              }
        };
    return (
      <Wrp>
        {
        (filterObject.input_value_type==='Timestamp')
        ?
        <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider utils={MomentUtils} >
                      <KeyboardDatePicker
                        fullWidth
                        keyboard
                        clearable
                        // margin="normal"
                        defaultValue={null} 
                        value={isSet(dispValue,null)}
                        // value={(isSet(dispValue,null)!==null && isSet(dispValue,null)!=='Invalid date')?moment(dispValue, getDateFormat(), true):null}//this.state.selectedDate}//attr.value}
                        // disablePast
                        onChange={this.fieldOnChangeHandler}
                        label=""
                        // clearable={true}
                        InputProps={{
                          ...attr,
                          // className:'form-control',
                          style: {fontSize: '0.8rem',borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px',paddingLeft:'4px'},
                          disableUnderline: true,
                          autoComplete:'off',
                          placeholder: getDateFormat('Date'),
                          onFocus:handleFocusOrClick,
                          onClick:handleFocusOrClick,
                          onKeyDown:(e)=>{handleKeyDown(e)}
                        }}
                        // readOnly={readonlyVal} 
                        //  variant={'inline'}       
                        // showTodayButton 
                        format={getDateFormat('Date')}
                        />
                      </MuiPickersUtilsProvider> 
                  </ThemeProvider>
        // <Datetime 
        // timeFormat={false} 
        // value={ this.props.value ? moment(this.props.value).format(getDateFormat('Date')) : ''}
        // // value={this.props.value} 
        // //value={ this.props.value ? moment(this.props.value).format(getDateFormat(this.props.attr2)) : ''}
        // dateFormat={getDateFormat('Date')} 
        // closeOnSelect={true}  
        // onChange={e=>this.props.filterOnChange(e, this.props.attr1, this.props.fieldtype, filterObject.has_multiple_input,this.props.attr5,this.props.attr6)}  
        // />
        : filterObject.input_value_type === "Integer" ?
        <Wrp>
        <input type="number" value={this.props.value} className={classname} onKeyPress={numericValidation} onChange={e=>this.props.filterOnChange(e, this.props.attr1, 'inputField', filterObject.has_multiple_input,this.props.attr4,this.props.attr6)} /> 
          {filterObject.name === "is in" ? "day(s) next" : "day(s) ago"}
        </Wrp>
        : null
        }
      </Wrp>
      

    )
  }
}

DatePick.defaultProps = {
className:'form-control'
//id:"replaceColumnInput"+JSON.parse(this.props.fieldDetails.colIndex)
}

export default DatePick;
